import React, { useEffect, useState } from "react";

import Loading from "wrappers/Loading";

import Page from "components/Page";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import { PASOS_BREADCRUMBS } from "utils/constants";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";

import {
  urlCatalogoCotizador,
  urlDataPlanes,
  urlNumHijos,
  urlPlanSelected,
} from "constants/urls";
import Plan from "./Plan";
import MessageMia from "./MessageMia";
import useCustomRouter from "hooks/useCustomRouter";
import { ApiKeyFetch } from "api/fetchers/apiKey";
import useUsuario from "hooks/useUsuario";
import COLORS from "utils/constants/COLORS";
import { BaseButton } from "components/InputsMex/inputs";
import BreadCrumbSegukids from "components/BreadCrumbMex/BreadCrumbSegukids";

const PlanesKids = ({ qParams }) => {
  const { idCotizacion } = qParams;

  const [loading, setLoading] = useState(false);

  const history = useCustomRouter();

  const { userIsLoggedIn, cliCodigoCore } = useUsuario();

  const [idPaquete, setIdPaquete] = useState();

  const [planes, setPlanes] = useState([]);

  const [rangeValue, setRangeValue] = useState(1);

  const [labelChild, setLabelChild] = useState("Hijo");

  const [nombres, setNombres] = useState("");

  const [agente, setAgente] = useState();

  const [cargando, setCargando] = useState(false);

  const [planSeleccionado, setplanSeleccionado] = useState(null);

  const numberChild = async () => {
    setLoading(true);

    const dataChild = await ApiKeyFetch.instance().post(urlNumHijos, {
      idCotizacion: idCotizacion,
    });

    if (dataChild.transaccion === true) {
      let hijo = dataChild.data?.catalogo.numHijos;
      setRangeValue(hijo);
      getDataPlan(hijo);
    }
  };

  const maxHijos = 5;
  let res = (rangeValue * 100) / maxHijos - 20;
  const labelStyle = {
    left: `${res}%`,
  };

  const handleRangeChange = (event) => {
    let valueInput = event.target.value;
    setCargando(true);
    if (valueInput === 1) {
      setLabelChild("Hijo");
    } else {
      setLabelChild("Hijos");
    }
    setRangeValue(valueInput);
    getDataPlan(valueInput);
  };

  useEffect(() => {
    numberChild();
  }, []);

  const getDataPlan = async (hijo) => {
    if (hijo < 2) {
      setLoading(true);
    }
    const body = {
      idCotizacion: idCotizacion,
      nombrecatalogo: "planes",
      usuCotiza: {
        usuCodigo: cliCodigoCore || "",
        codigoAgente: 77657,
      },
      numHijos: hijo,
      formasDePago: {
        idPlazo: 1,
        tipo: "contado",
        label: "CONTADO",
      },
      pasoCodigo: "planSeleccionado",
    };

    const resResumen = await ApiKeyFetch.instance().post(urlDataPlanes, body);
    //console.log("RES", resResumen);
    if (resResumen.transaccion === true) {
      setCargando(false);
      setNombres(
        resResumen.data.catalogo.datosContratante.usuNombre.split(" ")[0]
      );

      resResumen.data.catalogo.paquetes.map(
        (item) => (
          setPlanes(item.planes.sort((a, b) => b.id - a.id)),
          setIdPaquete(item.id)
        )
      );

      setLoading(false);
    } else {
      alert(resResumen.mensajes.usuCotiza);
    }
    if (hijo < 2) {
      setLoading(false);
    }
  };

  const seleccionarPlan = async (planID, PlanUID) => {
    setLoading(true);
    let agenteValue = null;
    if (!userIsLoggedIn) {
      agenteValue = 77657;
    } else {
      agenteValue = 77657;
    }
    try {
      let body = {
        usuCotiza: {
          usuCodigo: cliCodigoCore || "",
          codigoAgente: agenteValue,
        },
        idCotizacion: idCotizacion,
        nombrecatalogo: "planes",
        planSeleccionado: {
          paqueteID: idPaquete,
          planID: planID,
          PlanUID: PlanUID,
        },
        formasDePago: {
          idPlazo: 1,
          tipo: "contado",
          label: "CONTADO",
        },
        numHijos: rangeValue,
        pasoCodigo: "planSeleccionado",
        tarifarPlanSeleccionado: false,
      };
      const response = await ApiKeyFetch.instance().post(urlPlanSelected, body);

      if (response.transaccion === true) {
        history.push(`/kids/pago?idCotizacion=${idCotizacion}`);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const continuar = () => {
    history.push(`/kids/pago?idCotizacion=${idCotizacion}`);
  };
  const onClickAtras = () => {
    history.push(`/kids/cotizacion?idCotizacion=${idCotizacion}`);
  };

  return (
    <Loading loading={loading}>
      <Page>
        <BreadCrumbSegukids
          {...PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS].breadCrumbPasosSegukids[2]}
          pasos={PASOS_BREADCRUMBS[PRODUCTOS.SEGUKIDS]?.pasosContratante}
          showImg={false}
          showImgTitle={true}
          subtitleClassnames={"col-md-12 mb-0"}
          styleWidthImg={"padding0"}
        />

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <MessageMia
                textMessage={
                  "¡Gracias " +
                  nombres +
                  "!, te comparto tres opciones para asegurar a quienes más amas."
                }
              ></MessageMia>
            </div>
          </div>
          <div className="border mb-5 ">
            <div className="row mt-5">
              <div className="col-md-12">
                <h2 className="text-center text-mex">
                  Planes SeguKids & Teens
                </h2>
              </div>
            </div>
            <div className="row top30 mx-4 align-items-end">
              <div className="col-md-4 pr-0">
                <div className="cuantos">
                  ¿Cuántos hijos te gustaría asegurar?
                </div>
              </div>
              <div className="col-md-8 align-self-end pl-0">
                <div className="range-counter">
                  <input
                    type="range"
                    id="range-input"
                    min="1"
                    disabled={cargando}
                    max={maxHijos}
                    value={rangeValue}
                    className="range-input"
                    onChange={handleRangeChange}
                  />
                  <div className="range-counter__label" style={labelStyle}>
                    {rangeValue} {labelChild}
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4 mb-4 mx-4">
              {planes.map((item, index) => (
                <div className="col-md-4" key={index}>
                  <Plan
                    plan={item}
                    showBtnDescarga={false}
                    childSelect={rangeValue}
                    loading={cargando}
                    fnPlan={(planID, PlanUID) => {
                      seleccionarPlan(planID, PlanUID);
                    }}
                  />
                </div>
              ))}
            </div>
            <div className="row">
              <div className="col-md-4 offset-md-4 mb-5">
                <BaseButton
                  onClick={onClickAtras}
                  type="button"
                  textColor="white"
                  bgColor={COLORS.primary}
                >
                  <i
                    className="pi pi-arrow-left"
                    style={{
                      position: "relative",
                      top: "1px",
                      fontSize: "1.4rem",
                    }}
                  />{" "}
                  Atrás
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </Page>
    </Loading>
  );
};

export default PlanesKids;
